const translations = {
    carrierRate: 'Carrier rate',
    dryProductRate: 'Product rate (dry)',
    liquidProductRate: 'Product rate (liquids)',
    none: 'None',
    notSet: 'Not set',
    totalRate: 'Total rate',
    totalVolume: 'Total tank mix volume',
    unitFluidOunces: 'Fl. Oz',
    unitFluidOuncesPerAcre: 'Fl. Oz/Ac',
    unitGallons: 'Gal',
    unitGallonsPerAcre: 'Ga/Ac',
    unitLiters: 'L',
    unitLitersPerHectare: 'L/Ha',
    unitPints: 'Pt',
    unitPoundsPerAcre: 'Lb/Ac',
    unitQuarts: 'Qt'
};

export default translations;
